(function() {
 
  'use strict';

  $(".ui.sidebar").sidebar('attach events', '.sidebar-trigger');
  $('.ui.dropdown').dropdown();
  $('.ui.checkbox').checkbox();
  $('[data-popup="true"]').popup({
    position: "bottom right",
    on: 'click'
  });
  
  var owl =$('.carousel .owl-carousel').owlCarousel({
    items: 1,
    loop: true,
    autoHeight: true,
    // autoplay: true,
    autoplayTimeout: 7000,
    autoplayHoverPause: true,
    nav: true,
    navText: ['<i class="chevron left big icon"></i>', '<i class="chevron right big icon"></i>'],
    dots: true
  });
  owl.on('changed.owl.carousel', function(event) {
    $(".owl-carousel-bg > img").eq(event.page.index).fadeIn().siblings().fadeOut();
  });

  $(".author.owl-carousel").owlCarousel({
    autoHeight: true,
    responsiveClass:true,
    responsive : {
      0: {
        items : 1,
        dots: true,
        navText: ['<i class="chevron left icon"></i>', '<i class="chevron right icon"></i>']
      },
      // breakpoint from 768 up
      768 : {
        items: 3,
        dots: false,
        navText: ['<i class="chevron left icon"></i>', '<i class="chevron right icon"></i>']
      },
      992: {
        navText: ['<i class="chevron left big icon"></i>', '<i class="chevron right big icon"></i>']
      }
    },
    nav: true,
    margin: 30
  })
 
})();

